import {connect} from "react-redux"
import State from "../../models/State"
import {setPageItemsThunk} from "../../ducks/search"

const mapStateToProps = (state: State) => {
    const {search, template} = state
    return {
        containerMaxWidth: search.containerMaxWidth,
        templating: template,
    }
}

export const mapDispatchToProps = {
    loadPageFromUrl: (historyUrl: string) => setPageItemsThunk({historyUrl}),
}

export default connect(mapStateToProps, mapDispatchToProps)
